let initialState = {
  sis: false,
  name: '',
  domain: '',
  subHeaderHeight: 0,
  primaryHeaderHeight: 90,
  subHeaderLogoHeight: 0,
  showStoreNav: false,
  validateOTP: false,
  layoutModal: {
    content: '',
    showModal: false,
    optional: {},
    showToast: false,
    toastContent: ''
  }
};

export default function WebPageData(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_WEBPAGE_METADATA': {
      return { ...state, ...action.metaData };
    }

    case 'RESET_WEBPAGE_METADATA': {
      return initialState;
    }

    case 'UPDATE_SUBHEADER_HEIGHT': {
      return { ...state, subHeaderHeight: action.height };
    }

    case 'UPDATE_PRIMARY_HEIGHT': {
      return { ...state, primaryHeaderHeight: action.height };
    }

    case 'UPDATE_SUBHEADER_LOGO_HEIGHT': {
      return { ...state, subHeaderLogoHeight: action.subLogoHeight };
    }

    case 'SWITCH_SIS_ON': {
      return { ...state, subHeaderHeight: 100, subHeaderLogoHeight: 35, sis: true };
    }

    case 'TOGGLE_STORE_NAV': {
      return { ...state, showStoreNav: !state.showStoreNav };
    }

    case 'SET_CURRENT_STORE_THEME': {
      let { current = {} } = state;
      current = { ...current, ...action.current };
      return { ...state, current };
    }

    case 'SET_NAVIGATION_INFORMATION': {
      return { ...state, navigation: { ...action.navDataObj } };
    }

    case 'SET_SUB_STORE_NAVIGATION': {
      let { current = {} } = state;
      current.navigation = action.navigation;
      return { ...state, current };
    }

    case 'SHOW_LAYOUT_MODAL': {
      let { layoutModal = {} } = state;
      layoutModal = { ...layoutModal, ...action.payload };
      return { ...state, layoutModal };
    }

    case 'HIDE_LAYOUT_MODAL': {
      let { layoutModal = {} } = state;
      layoutModal = { ...layoutModal, ...action.payload };
      return { ...state, layoutModal };
    }

    case 'SHOW_LAYOUT_TOAST': {
      let { layoutModal = {} } = state;
      layoutModal = { ...layoutModal, ...action.payload };
      return { ...state, layoutModal };
    }

    case 'HIDE_LAYOUT_TOAST': {
      let { layoutModal = {} } = state;
      layoutModal = { ...layoutModal, ...action.payload };
      return { ...state, layoutModal };
    }

    case 'VALIDATE_OTP_TOGGLE': {
      return { ...state, validateOTP: true };
    }

    default:
      return state;
  }
}
